import * as React from 'react';
import {
  Map as FullwidthMap,
  IMapCoordinates,
  IMapGeoObject,
  TMapGeoObjectsFetchFunction,
} from '@cian/frontend-newbuilding-map-component';
import { TCustomBalloonFetchHtmlFunction } from '@cian/frontend-newbuilding-map-component/es/types';
import * as styles from './Map.css';

interface IProjectsMapProps {
  apiKey: string;
  currentTypes: string[];
  onCustomBalloonHtmlFetch: TCustomBalloonFetchHtmlFunction;
  onGeoObjectClick: (object: IMapGeoObject) => void;
  onGeoObjectsFirstFetch: TMapGeoObjectsFetchFunction;
  pinCoordinates: IMapCoordinates;
  zoom: number;
}

export function Map({
  apiKey,
  currentTypes,
  onCustomBalloonHtmlFetch,
  onGeoObjectClick,
  onGeoObjectsFirstFetch,
  pinCoordinates,
  zoom,
}: IProjectsMapProps) {
  return (
    <div className={styles['map']}>
      <FullwidthMap
        geoObjectNames={currentTypes}
        media={[
          {
            minWidth: -Infinity,
            maxWidth: Infinity,
            options: {
              center: pinCoordinates,
              styles: { width: '100%', height: '100%' },
              animationDuration: 300,
              defaultZoom: zoom,
            },
          },
        ]}
        firstPaintOptions={{
          apiKey,
          fetch: {
            onGeoObjectsFetch: onGeoObjectsFirstFetch,
            onCustomBalloonHtmlFetch,
          },
          onGeoObjectClick,
          id: 'developer-map',
          controls: [{ type: 'ZoomControl' }, { type: 'GeolocationControl' }, { type: 'FullscreenControl' }],
          styles: { width: '100%', height: '100%' },
          zoomRange: { min: 1, max: 17 },
          disableScrollZoom: true,
        }}
      />
    </div>
  );
}
